export default __webpack_public_path__ + "static/media/mucambo.f24391a0.png";